

export class ScoreValues {
    name: string;       // Hole, Par, Yardage, Handycap, Bobby, Joe, Dark
    order?: number;
    values: number[];

    get sumOut(): number {
        return this.values.slice(0, 9).reduce((a, b) => a + b, 0);
    }

    get sumIn(): number {
        return this.values.slice(9, 19).reduce((a, b) => a + b, 0);
    }

    get valuesOut(): number[] {
        return this.values.slice(0, 9);
    }

    get valuesIn(): number[] {
        return this.values.slice(9, 19);
    }
}


// hole, par, yardage, hcp
